// extracted by mini-css-extract-plugin
module.exports = {"root":"_2SC7y","mobileNavigationBtn":"_1j8UH"};